import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaUpload,
  FaPencilAlt,
  FaFileAlt,
  FaArrowRight,
  FaInfoCircle,
} from "react-icons/fa";

const OptionCard = ({
  title,
  description,
  icon,
  linkTo,
  buttonText,
  gradient,
}) => (
  <motion.div
    whileHover={{ scale: 1.03 }}
    className={`bg-gradient-to-br ${gradient} rounded-lg shadow-lg p-6 flex flex-col justify-between`}
  >
    <div>
      <div className="flex items-center mb-4">
        <div className="bg-white p-3 rounded-full text-purple-600">{icon}</div>
        <h3 className="text-xl font-bold ml-4 text-white">{title}</h3>
      </div>
      <p className="text-white text-opacity-90 mb-6">{description}</p>
    </div>
    <Link to={linkTo} className="mt-auto">
      <motion.button
        whileTap={{ scale: 0.98 }}
        className="w-full py-2 bg-white text-purple-600 rounded-md hover:bg-purple-100 transition duration-300 flex items-center justify-center font-semibold"
      >
        {buttonText}
        <FaArrowRight className="ml-2 text-sm" />
      </motion.button>
    </Link>
  </motion.div>
);

const CreateContract = () => {
  return (
    <div className="min-h-screen mt-4 bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl w-full space-y-8">
        <div className="text-center">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl font-extrabold text-slate-800 mb-2"
          >
            Create Contracts
          </motion.h1>
          <p className="text-purple-600 text-opacity-75 mb-8">
            Choose an option to start creating your contract
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <OptionCard
            title="Bulk Upload"
            description="Auto-extract metadata from XML files for multiple scanned PDF contracts."
            icon={<FaUpload size={30} className="text-xl" />}
            linkTo="/bulk-upload-form"
            buttonText="Upload Contracts"
            gradient="from-slate-700 to-purple-500"
          />
          <OptionCard
            title="Manual Creation"
            description="Fill out contract details and upload the document yourself."
            icon={<FaPencilAlt size={30}  className="text-xl" />}
            linkTo="/manual-create-form"
            buttonText="Create Contract"
            gradient="from-purple-800 to-pink-500"
          />
          <OptionCard
            title="Generate Contract"
            description="Use our AI-powered tool to generate a new contract document."
            icon={<FaFileAlt size={30} className="text-xl" />}
            linkTo="/documents/:id"
            buttonText="Generate Contract"
            gradient="from-pink-500 to-purple-900"
          />
        </div>
        <div className="mt-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center px-4 py-2 bg-purple-100 text-purple-700 rounded-full text-sm"
          >
            <FaInfoCircle size={24} className="mr-2" />
            Need help? Check our{" "}
            <Link to="#" className="underline ml-1">
              FAQ
            </Link>{" "}
            or{" "}
            <Link to="#" className="underline ml-1">
              contact support
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default CreateContract;
